import { COLORS_MAP } from '../components/constants';
import type { ColorToken } from '../components/types';

export function isColorToken(value: string): value is ColorToken {
  return Object.hasOwn(COLORS_MAP, value);
}
